/**
 * Controls held inside a layout control, wherever its config keeps them. Used to find every control
 * on a form, including ones inside cards, panels, tabs, steps and sections.
 */

import type { FormControl } from '@atlas-forms/types-js';

/** Config keys whose entries each hold their own `controls` list */
const ENTRY_LIST_KEYS = ['tabs', 'steps', 'sections'] as const;

export function nestedControls(control: FormControl): FormControl[] {
  const config = (control.config ?? {}) as Record<string, unknown>;
  const found: FormControl[] = [];

  if (Array.isArray(config.controls)) found.push(...(config.controls as FormControl[]));

  for (const key of ENTRY_LIST_KEYS) {
    const entries = config[key];
    if (!Array.isArray(entries)) continue;
    for (const entry of entries as Array<{ controls?: unknown }>) {
      if (Array.isArray(entry?.controls)) found.push(...(entry.controls as FormControl[]));
    }
  }

  // Legacy layouts (CardContainerControl) keep their content on `children`
  const children = (control as FormControl & { children?: unknown }).children;
  if (Array.isArray(children)) found.push(...(children as FormControl[]));

  return found;
}
